export default "__VITE_ASSET__3391cb4b__"